// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-color-picker {
  display: inline-block;
  position: relative;
  line-height: 0;
  width: -moz-fit-content;
  width: fit-content;
  vertical-align: text-top;
}
.dl-color-picker__palette-trigger {
  width: 28px;
  height: 28px;
}
.dl-color-picker__palette-trigger {
  --g-button-border-radius: 6px;
}
.dl-color-picker__color-item {
  border: 1px solid transparent;
}`, "",{"version":3,"sources":["webpack://./src/ui/units/dash/containers/Dialogs/components/ColorPicker/ColorPicker.scss"],"names":[],"mappings":"AAEA;EAEI,qBAAA;EACA,kBAAA;EACA,cAAA;EACA,uBAAA;EAAA,kBAAA;EACA,wBAAA;AAFJ;AAMI;EACI,WAHc;EAId,YAJc;AAAtB;AAOI;EAEI,6BAAA;AANR;AASI;EACI,6BAAA;AAPR","sourcesContent":[".dl-color-picker {\n  display: inline-block;\n  position: relative;\n  line-height: 0;\n  width: fit-content;\n  vertical-align: text-top;\n}\n.dl-color-picker__palette-trigger {\n  width: 28px;\n  height: 28px;\n}\n.dl-color-picker__palette-trigger {\n  --g-button-border-radius: 6px;\n}\n.dl-color-picker__color-item {\n  border: 1px solid transparent;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
